import React, { useState, useEffect } from 'react';
import {
  Form,
  Input,
  InputNumber,
  Checkbox,
  Button,
  Modal,
  Select,
} from 'antd';
import apiService from '../api/apiService';

function RateModel({ isOpen, onClose, onSave, existingData }) {
  const [form] = Form.useForm();
  const [error, setError] = useState('');
  const [roomTypes, setRoomTypes] = useState([]);
  const [deals, setDeals] = useState([]);

  useEffect(() => {
    if (existingData) {
      form.setFieldsValue({
        roomType: existingData.room_type || '',
        deals: existingData.deals || 'Custom Deal',
        cancellationPolicy: existingData.cancellation_policy || '',
        dealPrice: existingData.deal_price || 0,
        rate: existingData.rate || '',
        availability: existingData.availability || false,
      });
    } else {
      form.resetFields(); // Reset form fields when no existing data
    }
  }, [existingData, form]);

  useEffect(() => {
    fetchRoomTypes();
    fetchDeals();
  }, []);

  const fetchRoomTypes = async () => {
    try {
      const response = await apiService.get('/rooms/');
      setRoomTypes(response);
      console.log(response);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchDeals = async () => {
    try {
      const response = await apiService.get('/deals/');
      setDeals(response);
      console.log(response);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSaveAndEdit = async values => {
    const newRate = {
      room_type: values.roomType,
      deals: values.deals || 'test',
      cancellation_policy: values.cancellationPolicy,
      deal_price: values.dealPrice,
      rate: values.rate,
      availability: values.availability,
    };
    try {
      if (existingData) {
        const response = await apiService.put(
          `/rates/${existingData.id}/`,
          newRate
        );
        onSave(response);
      } else {
        // Make POST request
        const response = await apiService.post('/rates/', newRate);
        onSave(response);
      }
      handleCancel();
    } catch (error) {
      setError('Failed to save the rate.');
    }
  };

  const handleCancel = () => {
    form.resetFields();
    setError('');
    onClose();
  };

  const availabilityLabel = {
    fontWeight: 500,
  };

  if (!isOpen) return null;

  return (
    <Modal
      centered
      title={existingData ? 'Edit Rate' : 'Add Rate'}
      open={isOpen}
      onCancel={handleCancel}
      footer={null}
    >
      <Form form={form} layout="vertical" onFinish={handleSaveAndEdit}>
        <Form.Item
          label="Room Type"
          name="roomType"
          rules={[{ required: true, message: 'Please enter the room type' }]}
        >
          <Select placeholder="Select Room Type">
            {roomTypes.map(roomType => (
              <Option key={roomType.id} value={roomType.id}>
                Room {roomType.room_number} - {roomType.room_type.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Deals"
          name="deals"
          rules={[{ required: true, message: 'Please enter the deal name' }]}
        >
          <Select placeholder="Select a deal">
            {deals.map(deal => (
              <Option key={deal.id} value={deal.deal_name}>
                {deal.deal_name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Cancellation Policy"
          name="cancellationPolicy"
          rules={[
            {
              required: true,
              message: 'Please enter the cancellation policy',
            },
            {
              pattern: new RegExp(/^[a-zA-Z\s]+$/),
              message:
                'Cancellation policy must only contain letters and spaces',
            },
          ]}
        >
          <Input placeholder="Enter cancellation policy" />
        </Form.Item>

        <Form.Item
          label="Deal Price"
          name="dealPrice"
          rules={[{ required: true, message: 'Please enter the deal price' }]}
        >
          <InputNumber
            min={0}
            step={0.01}
            style={{ width: '100%' }}
            placeholder="Enter deal price"
          />
        </Form.Item>

        <Form.Item
          label="Rate"
          name="rate"
          rules={[{ required: true, message: 'Please enter the rate' }]}
        >
          <InputNumber
            min={0}
            step={0.01}
            style={{ width: '100%' }}
            placeholder="Enter rate"
          />
        </Form.Item>

        <Form.Item name="availability" valuePropName="checked">
          <Checkbox>
            <span style={availabilityLabel}>Availability</span>
          </Checkbox>
        </Form.Item>

        <div className="form-actions d-flex justify-content-end">
          <Button onClick={handleCancel} style={{ marginRight: 8 }}>
            Cancel
          </Button>
          <Button type="primary" htmlType="submit">
            Save
          </Button>
        </div>
      </Form>
    </Modal>
  );
}

export default RateModel;
